
import { AgGridReact, CustomCellRendererProps } from "ag-grid-react";
// import { themeGrid } from "../../../../../themeGrid";
// import { localeText } from "../../../../../localeTextFromGrid";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import dayjs from "dayjs";
import { themeGrid } from "../../../../../themeGrid";
import { localeText } from "../../../../../localeTextFromGrid";
import { useRef, useState } from "react";
import { IGetCertificationsDto } from "../../../../../@types/curriculum.type";
// import { themeGrid } from "../../../../themeGrid";
// import { localeText } from "../../../../localeTextFromGrid";


const columnsDefault: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "certification",
    headerName: "Nome",
    flex: 1,
    minWidth: 200,
  },
  {
    field: "certificationDate",
    headerName: "Data",
    maxWidth: 100,
    flex: 1,
    minWidth: 200,
    cellRenderer: (params: CustomCellRendererProps) => {
      return params.value ? dayjs(params.value).format("MM/YYYY") : "";
    },
  },
];


interface CertificationGridProps {
  certifications: IGetCertificationsDto[];
}

export const CertificationGrid: React.FC<CertificationGridProps> = ({
  certifications
}) => {
  
  const [columns, setColumns] = useState(columnsDefault);
  const [loading, setLoading] = useState<boolean>(false);
  const gridRef = useRef<AgGridReact<any>>(null);

  const getDataSource = () => ({
    getRows: async (params: IGetRowsParams) => {
      try {
        const response = certifications;

        if(response)
          params.successCallback(
            response,
            response.length
          );
        
      } catch (error) {
        console.log(error);
      }
    }
  });

  return (
    <>
      <AgGridReact
        ref={gridRef}
        theme={themeGrid}
        localeText={localeText}
        loading={loading}
        columnDefs={columns}
        overlayNoRowsTemplate="<span style='color: gray;'>Sem registros encontrados</span>"
        defaultColDef={{
          sortable: false,
          editable: false,
          filter: false,
          floatingFilter: false,
        }}
        suppressCellFocus={true}
        rowStyle={{ cursor: "pointer" }}
        rowModelType="infinite"
        datasource={getDataSource()}
        animateRows={true}
        infiniteInitialRowCount={10}
      />
    </>
  );
};
